"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._devMode = exports.BRANCH_EXTRA_DATA_ATTRIBUTE = exports.SubscriptionPlans = exports.DATE_FORMAT = exports.ADMIN = exports.AREA_MANAGER = exports.BRANCH_MANAGER = exports.CLIENT = exports.BRANCH = exports.UPGRADE_MODAL_TITLE = exports.REQUEST_ERROR_TITLE = exports.PLATFORM = exports.VAT = void 0;
exports.VAT = 0.15;
exports.PLATFORM = "LETSTRADE";
exports.REQUEST_ERROR_TITLE = "Something went wrong!";
exports.UPGRADE_MODAL_TITLE = "Upgrade Required";
exports.BRANCH = "BRANCH";
exports.CLIENT = "CLIENT";
exports.BRANCH_MANAGER = "BRANCH_MANAGER";
exports.AREA_MANAGER = "AREA_MANAGER";
exports.ADMIN = "ADMIN";
exports.DATE_FORMAT = "YYYY-MM-DD";
var SubscriptionPlans;
(function (SubscriptionPlans) {
    SubscriptionPlans["FREEMIUM"] = "FREEMIUM";
    SubscriptionPlans["BUSINESS"] = "BUSINESS";
    SubscriptionPlans["STARTER"] = "STARTER";
    SubscriptionPlans["GROWTH"] = "GROWTH";
})(SubscriptionPlans = exports.SubscriptionPlans || (exports.SubscriptionPlans = {}));
exports.BRANCH_EXTRA_DATA_ATTRIBUTE = [
    {
        label: "tenant_id",
        description: "Used t fetch bikes on digital twin for delivery",
    },
    {
        label: "services",
        description: "List of Branch services separated by comma",
    },
    {
        label: "type",
        description: "Type of branch",
    },
    {
        label: "basket_minimum_value",
        description: "Numerical value that the basket total should be before allowing a user to place an order. (Minimum price of order)",
    },
    {
        label: "maximum_per_product",
        description: "Numerical value that dictates the maximum quantity per product line before allowing a user to place an order",
    },
    {
        label: "maximum_basket_size",
        description: "Numerical value that dictates the maximum quantity of all products in a basket before allowing a user to place an order",
    },
];
exports._devMode = process.env.ENVIRONMENT !== "PROD" || process.env.NODE_ENV !== "production";
